import type { Map } from 'leaflet';
import { useEffect } from 'react';
import { useMapEvent } from 'react-leaflet';

import { useActions } from '@/overmind';

const getMapCenterPayload = (map: Map) => {
  return { zoom: map.getZoom(), center: map.getCenter() };
};

export function SaveMapPosition() {
  const { setMapCenter } = useActions().map;
  const map = useMapEvent('moveend', () => {
    setMapCenter(getMapCenterPayload(map));
  });

  useEffect(() => {
    if (map) {
      setMapCenter(getMapCenterPayload(map));
    }
  }, [map, setMapCenter]);
  return null;
}
